import { AlertOutlined, DatabaseOutlined, HistoryOutlined } from '@ant-design/icons';
import { Button, Dropdown, Layout, Menu, Space, Typography } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import LogoWithText from 'components/logo-components/logoWithText';
import NavNotification from '../NavNotification';
import NavProfile from '../NavProfile';
import RouteList from './route-list';
import SelectBranch from '../SelectBranch';
import { SpLanguageSwitch } from 'features/shared';
import TeamStore from 'mobx/TeamStore';
import UserStore from 'mobx/UserStore';
import _ from 'lodash';
import { checkTimeOutAccessToken } from 'utils/accessAuth';
import useBreakpoints from 'hooks/useBreakpoints';
import { useEffect } from 'react';
import usePermissionWall from 'hooks/usePermissionWall';
import { useTranslation } from 'react-i18next';

const { Header } = Layout;

const InsideHeader = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();
  const { isSmallScreen } = useBreakpoints();
  const selectedKeys = location.pathname;
  const explode = selectedKeys.split('/');

  const isNotSmallScreen = !isSmallScreen;

  const { hasTouchModules, hasTouchSubModules } = usePermissionWall();

  const explodeKey = explode[2] === 'one-command' ? explode[3] : explode[2];

  const AttempSelect = () => {
    const jp = [...RouteList[explodeKey]].reverse().find((el) => el.path !== '' && selectedKeys === el.path);
    return _.get(jp, 'path', null);
  };

  const AttempSubSelect = () => {
    const jp = RouteList[explodeKey].find((el) => el.path !== '' && selectedKeys.includes(el.path));
    // const jp = null

    if (jp && jp.children && jp.children.length > 0) {
      const atim = jp.children.find((ez) => selectedKeys.includes(ez.path));
      return _.get(atim, 'path', null);
    }

    return null;
  };

  const filterRouterList = (items = []) => {
    try {
      const modules = items?.filter((ss) => {
        if (!ss.query?.group) {
          return ss;
        }

        const hasModules = hasTouchModules(ss.query.group);

        if (ss?.query?.type) {
          return (
            hasTouchSubModules({
              moduleName: ss.query.group,
              subModuleName: ss?.query?.type,
              action: 'read',
            }) && hasModules
          );
        }

        return hasModules;
      });
      return modules;
    } catch (error) {
      return [];
    }
  };

  useEffect(() => {
    if (selectedKeys.includes('case-management')) {
      TeamStore.GetTeamList();
    }
  }, [selectedKeys]);

  useEffect(() => {
    if (Date.now() > UserStore.accessAuthen?.expires_at) {
      checkTimeOutAccessToken('403', false);
    }
  }, [UserStore.accessAuthen]);

  return (
    <div className="gx-header-horizontal gx-header-horizontal-dark gx-inside-header-horizontal">
      <Header className="gx-header-horizontal-main">
        <div className="gx-container">
          <div className="gx-header-horizontal-main-flex">
            <div className="gx-d-lg-block gx-pointer gx-mr-xs-5 gx-logo gx-my-3">
              {isNotSmallScreen && (
                <Link to="/">
                  <div style={{ height: 40, width: 'auto' }}>
                    <LogoWithText size={9} src="/app/launchpad" />
                  </div>
                </Link>
              )}
              {isSmallScreen && (
                <div style={{ height: 40, width: 'auto' }}>
                  <LogoWithText size={3} src="/app/launchpad" />
                </div>
              )}
            </div>
            {/* {false && ( */}
            {selectedKeys === '/app/alarm-monitoring' || selectedKeys === '/app/alarm-monitoring/list' ? (
              <Space>
                <Button
                  type="text"
                  style={{
                    backgroundColor: '#ffffff00',
                    border: 'none',
                  }}
                  disabled={selectedKeys === '/app/alarm-monitoring'}
                  onClick={() => {
                    navigate('/app/alarm-monitoring');
                  }}
                  icon={
                    <AlertOutlined
                      style={{
                        fontSize: 20,
                      }}
                    />
                  }
                >
                  Monitoring Alert
                </Button>

                <Button
                  type="text"
                  style={{
                    backgroundColor: '#ffffff00',
                    border: 'none',
                  }}
                  disabled={selectedKeys === '/app/alarm-monitoring/list'}
                  onClick={() => {
                    navigate('/app/alarm-monitoring/list');
                  }}
                  icon={
                    <HistoryOutlined
                      style={{
                        fontSize: 20,
                      }}
                    />
                  }
                >
                  Alarm Monitoring History
                </Button>
              </Space>
            ) : null}

            {isNotSmallScreen ? (
              <>
                <div
                  className="gx-header-horizontal-nav gx-header-horizontal-nav-curve"
                  style={{
                    width: 'calc(100% - 170px - 404px)',
                  }}
                >
                  {explode.length > 2 && RouteList[explodeKey] && (
                    <Menu
                      selectedKeys={[AttempSelect()]}
                      mode="horizontal"
                      className="ud-single-menu"
                      style={{ width: '100%' }}
                    >
                      {filterRouterList(RouteList[explodeKey]).map((el) => (
                        <Menu.Item key={el.path}>
                          {!el.children ? (
                            <Link to={el.path}>
                              {el.icon} <span>{multiLangName(i18n, el)}</span>
                            </Link>
                          ) : (
                            <Dropdown
                              overlay={
                                <Menu
                                  className="gx-mt-4"
                                  style={{
                                    display: filterRouterList(el.children).length <= 0 ? 'none' : 'block',
                                  }}
                                  activeKey={AttempSubSelect()}
                                  onClick={(e) => {
                                    if (e.key === '#') {
                                      return;
                                    }
                                    navigate(el.path + e.key);
                                  }}
                                >
                                  {filterRouterList(el.children).map((es, _ix) => {
                                    if (!es.children) {
                                      return (
                                        <Menu.Item
                                          key={es.path}
                                          className={`gx-py-2 ${es.path === '#' && 'gx-not-allowed'}`}
                                        >
                                          {es.icon} <span className="gx-ml-1">{multiLangName(i18n, es)}</span>
                                        </Menu.Item>
                                      );
                                    }
                                    return (
                                      <Menu.SubMenu
                                        key={es.path}
                                        title={multiLangName(i18n, es)}
                                        icon={<DatabaseOutlined />}
                                      >
                                        {filterRouterList(es.children).map((ez, __) => (
                                          <Menu.Item key={ez.path}>
                                            {ez.icon} <span className="gx-ml-1">{multiLangName(i18n, ez)}</span>
                                          </Menu.Item>
                                        ))}
                                      </Menu.SubMenu>
                                    );
                                  })}
                                </Menu>
                              }
                            >
                              <Typography.Text>
                                {el.icon} <span>{multiLangName(i18n, el)}</span>
                              </Typography.Text>
                            </Dropdown>
                          )}
                        </Menu.Item>
                      ))}
                    </Menu>
                  )}
                </div>
                <ul className="gx-header-notifications gx-ml-auto">
                  <li className="gx-notify">
                    <SelectBranch />
                  </li>
                  <li className="gx-notify">
                    <NavNotification {...props} />
                  </li>
                  <li className="gx-notify">
                    <SpLanguageSwitch />
                  </li>
                  <li className="gx-user-nav gx-m-0">
                    <NavProfile />
                  </li>
                </ul>
              </>
            ) : (
              <>
                <div className="gx-header-horizontal-nav gx-header-horizontal-nav-curve"></div>
                <ul className="gx-header-notifications gx-ml-auto">
                  <li className="gx-notify">
                    <SelectBranch />
                  </li>
                  <li className="gx-notify">
                    <NavNotification {...props} />
                  </li>
                  <li className="gx-notify">
                    <SpLanguageSwitch />
                  </li>
                  <li className="gx-user-nav gx-m-0">
                    <NavProfile />
                  </li>
                </ul>
              </>
            )}
          </div>
        </div>
      </Header>
    </div>
  );
};

export default InsideHeader;

const multiLangName = (i18n, element) => {
  switch (i18n.language) {
    case 'th':
      return element?.name_th;

    case 'en':
      return element?.name_en;

    default:
      return element?.name_th;
  }
};
